import { API_STATUS } from "../../../constants/apiStatus";

export const userPlanSliceInitialState = {
  plan: null,
  apiStatus: {
    getPlan: API_STATUS.IDLE,
    updatePlan: API_STATUS.IDLE,
    upgradePlan: API_STATUS.IDLE,
    downgradePlan: API_STATUS.IDLE,
  },
  error: null,
};
